import React, { useCallback, useEffect, useRef, useState } from "react";
import "./SpaceApp.css";
import { Canvas, useLoader } from "@react-three/fiber";
import { OrbitControls, Stars } from "@react-three/drei";

import * as THREE from "three";

// records:
import data from "./build/data/test.json";

// Build Components:
import Planet from "./build/Planet";
import Star from "./build/Star";
import EllipticalOrbit from "./build/EllipticalOrbit";
import { v } from "../env/env_variable";
import { useStateValue } from "../utils/provider/StateProvider";
import PlanetView from "./build/PlanetView";
import { reframePlanetData } from "./build/function/function";

function SpaceApp() {
  // Redux state
  const [{ user, searchText }, dispatch] = useStateValue();

  // All States:
  const [planet, setSelectedPlanet] = useState("");
  const [planetIndividualView, setIndividualPlanetView] = useState(false);
  const [planetIndividualViewData, setIndividualPlanetViewData] = useState();

  // Search Feature
  const [searchValue, setSearchValue] = useState("");
  const [filterSearchData, setFilterSearchData] = useState([]);
  const [handleCloseView, setHandleCloseView] = useState(false);

  const [hidePlanetName, setHidePlanetName] = useState(false);

  // Camera Refrences:
  let camera = new THREE.PerspectiveCamera(
    1,
    window.innerWidth / window.innerHeight,
    0.000001,
    10000000
  );
  let [x, y, z] = [0, 1, 2];
  camera.position.set(x, y, z);

  const canvasRef = useRef();

  useEffect(() => {
    const temp = [];
    Object.keys(data).map((i) => {
      Object.keys(data[i]).map((j) => {
        if (Array.isArray(data[i][j])) {
          const bodies = data[i][j];
          bodies.map((detail) => {
            temp.push({
              name: detail.name,
              type: detail.isPlanet ? "Planet" : "Star",
              id: detail.id,
            });
          });
        }
      });
    });

    const filterTemp = temp.filter(
      (item, index, self) => index === self.findIndex((t) => t.id === item.id)
    );

    setFilterSearchData([...filterTemp]);
  }, []);

  const setPlanetDataFtn = async (data) => {
    if (data.name === planet.name || data === "closeSearch") {
      setSelectedPlanet("");
    } else {
      const sample = reframePlanetData(data);

      Object.keys(sample).map((i) => {
        console.log(i, typeof sample[i]);
      });

      setSelectedPlanet(sample);
      setIndividualPlanetView(true);
      data.id = data.id + Math.random(1, 100);
      setIndividualPlanetViewData(data);
    }
  };

  const changeFocusOfCamera = useCallback(
    (position, diameter = 0) => {},
    [camera]
  );

  const showPlanet = (planet) => {
    dispatch({ type: "SEARCH_TEXT", searchText: planet });
    setSearchValue("");
    setHandleCloseView(true);
  };

  const exitPlanet = () => {
    dispatch({ type: "SEARCH_TEXT", searchText: null });
    setSearchValue("");
    setHandleCloseView(false);
    showPlanetName();
  };

  const onSearchSetValue = (value) => {
    setSearchValue(value);
  };

  const showPlanetName = () => {
    // Planet
    const planetElements = document.querySelectorAll(
      '[id^="planetNameClicked"]'
    );
    // Now, planetElements is a NodeList containing all elements with IDs that start with 'planetNameClicked-'.
    // You can loop through them or apply changes as needed.
    for (const planetElement of planetElements) {
      planetElement.style.display = "block";
    }
  };
  return (
    <div className="space_canvas">
      <Canvas ref={canvasRef} camera={camera}>
        <OrbitControls />
        <ambientLight intensity={0.8} />
        <pointLight position={[0, 0, 0]} intensity={0.4} />
        <Stars radius={1000000000000000} />

        {/* Sun at the center */}
        {data &&
          Object.keys(data).map((system) =>
            data[system].parent.map((star) => (
              <Star
                position={[0, 0, 0]}
                radius={star.diameter * v.sizeScalingFactor}
                data={star}
                onSetCameraFocus={(position) => changeFocusOfCamera(position)}
                camera={camera}
              >
                {data[system].bodies.map((planet) => (
                  <EllipticalOrbit
                    color="#BFBBDA"
                    name={planet.name}
                    semimajorAxis={
                      planet.semimajorAxis * v.distanceScalingFactor
                    }
                    eccentricity={planet.eccentricity}
                    inclination={planet.orbitalInclination}
                  />
                ))}
              </Star>
            ))
          )}

        {/* Rendering all planets */}
        {data &&
          Object.keys(data).map((system) =>
            data[system].bodies.map((planet) => (
              <group key={planet.name}>
                <Planet
                  position={[
                    (planet.distanceFromParent / v.posX) *
                      v.distanceScalingFactor +
                      Math.floor(Math.random() * 100),
                    0,
                    0,
                  ]}
                  radius={planet.diameter * v.sizeScalingFactor}
                  data={planet}
                  onSetCameraFocus={(position, diameter) =>
                    changeFocusOfCamera(position, diameter)
                  }
                  showPlanetName={hidePlanetName}
                  onSetPlanetData={(data) => {
                    setPlanetDataFtn(data);
                    setHidePlanetName(true);
                  }}
                ></Planet>
              </group>
            ))
          )}
          
      </Canvas>

      {/* Search planet
      {handleCloseView && planet ? (
        <div
          className="displayModalOnCanvas search_field_div_temp display_flex_row"
          onClick={() => exitPlanet()}
        >
          <p className="closeviewmodal">Exit from current View</p>
          <p className="closeviewmodal">X</p>
        </div>
      ) : (
        <div className="displayModalOnCanvas search_field_div_temp">
          <input
            className="search_field_input_item"
            type="text"
            placeholder="Search planet"
            value={searchValue}
            onChange={(e) => onSearchSetValue(e.target.value)}
          />
          {searchValue && (
            <div className="header_searchDiv_main">
              {filterSearchData &&
                filterSearchData.map(
                  (data) =>
                    data.name
                      .toLowerCase()
                      .includes(searchValue.toLowerCase()) && (
                      <div
                        className="header_searchVal_div"
                        onClick={() => showPlanet(data.name)}
                      >
                        <p>{data.name}</p>
                        <div className="header_searchVal_div_desc">
                          <p>{data.type}</p>
                          <p>id: {data.id}</p>
                        </div>
                      </div>
                    )
                )}
            </div>
          )}
        </div>
      )} */}

      {/* Showing individual planet view */}
      {planetIndividualView && planetIndividualViewData && (
        <div className="full_div_displayModalOnCanvas">
          <div
            className="displayModalOnCanvas search_field_div_temp display_flex_row"
            onClick={() => {
              setIndividualPlanetView(false);
              setIndividualPlanetViewData("");
              showPlanetName();
            }}
          >
            <p className="closeviewmodal">Exit from current View</p>
            <p className="closeviewmodal">X</p>
          </div>

          {planetIndividualViewData && (
            <PlanetView planetData={planetIndividualViewData} />
          )}
        </div>
      )}
    </div>
  );
}

export default SpaceApp;
